import { render, staticRenderFns } from "./Contatto-side.vue?vue&type=template&id=0b76e2a0&"
import script from "./Contatto-side.vue?vue&type=script&lang=js&"
export * from "./Contatto-side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports